import isDeletedStaff from '@medflex/utils/isDeletedStaff';
import isSelf from './isSelf';
import isSupportPatient from './isSupportPatient';

const contact = ({ firstName, lastName, title = '' }) =>
  `${lastName}, ${firstName} ${title}`.trim();
const self = ({ firstName, lastName, title = '' }) => `${title} ${firstName} ${lastName}`.trim();
const support = () => 'medflex Kundenbetreuung';

const get = ({ id, firstName, lastName, title }) => {
  if (isDeletedStaff(firstName)) return lastName;
  if (isSelf({ id })) return self({ firstName, lastName, title });
  if (isSupportPatient({ id })) return support();
  return contact({ firstName, lastName, title });
};

export default {
  contact,
  self,
  support,
  get,
};
